import { NgFor, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ProfileCandidateScoreRating } from 'src/app/martech/models/candidate-score-rating.model';
import { RatingNameComponent } from 'src/app/shared/components/rating-name/rating-name.component';

@UntilDestroy()
@Component({
    selector: 'nova-lead-score-profile-rating',
    templateUrl: './lead-score-profile-rating.component.html',
    styleUrls: ['./lead-score-profile-rating.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, RatingNameComponent, NgOptimizedImage]
})
export class LeadScoreProfileRatingComponent {
    readonly leadScoreProfiles = input<ProfileCandidateScoreRating[]>(undefined);
    readonly showIconAndHeader = input(false);
}
